<template>
  <a-card :body-style="{padding: '24px 32px'}" :bordered="false">

    <a-form @submit="handleSubmit" :form="form">

      <a-form-item
        label="数据来源"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }">
        <select-hospital ref="hospital" hidden />
        <a-select
          placeholder="请选择"
          @dropdownVisibleChange="loadHospital"
          v-decorator="[ 'hospital', {rules: [{ required: true, message: '请选择数据来源'}]} ]" >
          <a-select-option v-for="item in hospitals" :key="item.key">{{ item.value }}</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="患者姓名"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }" >
        <a-input placeholder="输入患者姓名" v-decorator="[ 'case_name']"/>
      </a-form-item>

      <a-form-item
        label="患者姓别"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }">
        <a-select placeholder="请选择患者姓别" v-decorator="['case_gender',{initialValue:'2'}]">
          <a-select-option value="0">男</a-select-option>
          <a-select-option value="1">女</a-select-option>
          <a-select-option value="2">未知</a-select-option>
        </a-select>
      </a-form-item>

      <a-form-item
        label="患者年龄"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }">
        <a-input
          name="age"
          placeholder="输入患者年龄"
          v-decorator="['case_age',{rules: [{pattern:'^\\d{1,3}$',message: '请输入正常年龄'}]}]"/>
      </a-form-item>

      <a-form-item
        label="诊断模型"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }">
        <select-model @modal_changed="handleModelChange" v-decorator="['model_id',{rules: [{ required: true, message: '请选择诊断模型'}]}]"/>
      </a-form-item>

      <a-form-item
        label="备注信息"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }">
        <a-textarea placeholder="输入备注信息" v-decorator="['diagnose_comments']"/>
      </a-form-item>

      <a-form-item
        label="数据上传"
        :labelCol="{lg: {span: 9}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 6}, sm: {span: 10} }">
        <upload-image
          ref="images"
          v-decorator="['images',{rules:[{ required: true, message: '请上传图片'}]}]"/>
      </a-form-item>

      <a-form-item
        :wrapperCol="{ span: 22 }"
        style="text-align: center"
      >
        <a-button htmlType="submit" type="primary" :loading="loading">提交</a-button>

      </a-form-item>
    </a-form>
  </a-card>
</template>

<script>
import UploadImage from '@/components/UploadImage'
import SelectHospital from '@/components/selector/SelectHospital'
import SelectModel from '@/components/selector/SelectModel'
import { addDiagnose } from '@/api/diagnose'

export default {
  name: 'AddDiagnose',
  components: {
    UploadImage,
    SelectHospital,
    SelectModel
  },
  data () {
    return {
      loading: false,
      file_uid: '',
      hospitals: [],
      value: 1,

      // form
      form: this.$form.createForm(this)

    }
  },
  created () {
    this.$on('add_data_ok', () => {

    })
  },

  methods: {
    loadHospital () {
      this.hospitals = this.$refs.hospital.values
    },
    handleModelChange (model) {
      this.form.setFieldsValue({ model_id: model })
    },

    handleSubmit (e) {
      const imageList = this.$refs.images.fileList
      if (imageList.length != 0) this.form.setFieldsValue({ images: 'true' })

      this.loading = true
      e.preventDefault()
      const _this = this
      this.form.validateFields((err, values) => {
        if (!err) {
          imageList.map(image => {
            const file_string = JSON.stringify({
              file_name: image.name,
              file_url: image.url,
              file_uid: image.fileUid
            })

            const params = {
              item_id: _this.$store.getters.projectId,
              source_id: values.hospital,
              file_string: file_string,
              data_des: values.data_des,
              case_name: values.case_name,
              case_gender: values.case_gender,
              case_age: values.case_age,
              model_id: values.model_id
            }

            addDiagnose(params).then(res => {
              _this.$message.success('添加成功')
              _this.$refs.images.fileList = []
            }).catch(() => {
              _this.$message.error('添加失败')
            }).finally(() => {
              this.loading = false
            })
          })
        } else this.loading = false
      })
    }
  }
}
</script>
